module.exports = "/_next/static/images/icon-no-3-6817421f.png";